import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import CustomBreadcrumbs from 'src/legacy/components/custom-breadcrumbs';
import Iconify from 'src/legacy/components/iconify';
import { useLocales } from 'src/legacy/locales';
import { PATH_DASHBOARD } from 'src/legacy/routes/paths';

import {
  defaultTabs,
  useFosterFamilyListNavigatorContext,
} from './FosterFamilyListNavigatorContext';

export const Breadcrumbs = () => {
  const { currentTab } = useFosterFamilyListNavigatorContext();
  const { translate } = useLocales();

  const pageName =
    defaultTabs.find(({ value }) => value === currentTab)?.label || 'profile';

  return (
    <CustomBreadcrumbs
      action={
        <Button
          component={RouterLink}
          startIcon={<Iconify icon="eva:plus-fill" />}
          to={PATH_DASHBOARD.fosterFamily.new}
          variant="contained"
        >
          {`${translate('new_foster_family')}`}
        </Button>
      }
      heading={`${translate('foster_families')}`}
      links={[
        { href: PATH_DASHBOARD.root, name: `${translate('dashboard')}` },
        {
          href: PATH_DASHBOARD.fosterFamily.root,
          name: `${translate('foster_families')}`,
        },
        { name: `${translate(pageName)}` },
      ]}
    />
  );
};
